/**
 * Кадр демонстрации вместе с разметкой — картинкой в переписку.
 *
 * ⭐ Ради этого разметку в итоге и открывают: разговор кончился, а стрелка
 * «вот этот узел» осталась в канале, где её найдут через неделю.
 *
 * Склейка идёт в НАТУРАЛЬНОМ размере кадра, а не в размере окна: у каждого
 * участника окно своё, и снимок «как у меня на экране» отдал бы в чат
 * случайное разрешение вместо того, что показывали.
 */

/** Собрать PNG из кадра видео и холста разметки поверх него. */
export async function compositeFrame(
  video: HTMLVideoElement | undefined,
  overlay: HTMLCanvasElement | undefined,
): Promise<Blob | undefined> {
  const width = video?.videoWidth ?? 0;
  const height = video?.videoHeight ?? 0;
  if (!video || !width || !height) return undefined;

  const target = document.createElement("canvas");
  target.width = width;
  target.height = height;

  const context = target.getContext("2d");
  if (!context) return undefined;

  context.drawImage(video, 0, 0, width, height);

  // Холст разметки живёт в экранных пикселях содержимого, но покрывает ровно
  // ту же область кадра — растягиваем его на весь кадр целиком.
  if (overlay && overlay.width && overlay.height) {
    context.drawImage(overlay, 0, 0, width, height);
  }

  return new Promise((resolve) =>
    target.toBlob((blob) => resolve(blob ?? undefined), "image/png"),
  );
}
